// as const tells TS this is a tupple and not simply { id: string, label: string }[]
export const customiseLabelsOptions = [
    {
        id: "show-roles",
        label: "Show Roles",
    },
    {
        id: "show-names",
        label: "Show Names",
    },
    {
        id: "reveal-labels",
        label: "Reveal Labels Not Shown",
    },
    {
        id: "show-experience-region",
        label: "Experience region",
    },
    {
        id: "show-typical-archetype-location",
        label: "Typical Archetype Locations",
    },
] as const;

// Getting an Union of the ids from options
export type TOptionsIds = typeof customiseLabelsOptions[number]["id"];

export type TCustomiseLabelsOptions = { [K in TOptionsIds]?: boolean };
